import { Injectable } from '@angular/core';
import { EMPTY, Observable, of, tap } from 'rxjs';
import { HttpService } from "../http.service";
import { LocalStorageService } from './localstorage.service';
import { SettingsService, setting_subjects } from './settings.service';
import { TokenService } from "../auth/token.service";

export enum EntityIDdisplay { none=0, displayIdAfter=1, displayIdBefore=2 } 

export type UserPreferences = {
   display: {
      IDdisplay: EntityIDdisplay
   }
}

const key='preferences'

@Injectable({
   providedIn: 'root'
})
export class UserPreferencesService {
   constructor(
      private HttpService: HttpService,
      private LocalStorageService: LocalStorageService,
      private TokenService: TokenService,
      private SettingsService: SettingsService
   ) { }

   getFromLocalstorage(): UserPreferences | boolean {
      if(!this.LocalStorageService.hasKey(key))
         return false
      let preferences=this.LocalStorageService.get(key)
      if(preferences && !this.isValid(preferences))
         return false
      return preferences
   }
   setInLocalstorage(preferences: UserPreferences) {
      this.LocalStorageService.set(key, preferences)
   }
   get(): Observable<any> {
      // Try to get from localstorage
      let preferences = this.getFromLocalstorage();
      if (preferences)   
         return of(preferences as UserPreferences);

      // Try to get the logged user ID 
      const userId = this.TokenService.getUserId()
      if(!userId) 
         // Return default preferences
         return of(this.getDefault());
      
      return this.SettingsService.getSubject(Number(userId), setting_subjects.user_preferences)
         .pipe( tap((data: any) => {
            // Store preferences in localstorage
            let preferences = data.settings;
            this.setInLocalstorage(this.isValid(preferences) ? preferences : this.getDefault());
         })         
      )
   }
   set(preferences: UserPreferences): Observable<any> {
      const userId = this.TokenService.getUserId()
      if(!userId) return EMPTY
      return this.SettingsService.setSubject(Number(userId), setting_subjects.user_preferences, 0, preferences)
         .pipe(tap(() => this.setInLocalstorage(preferences)))
   }

   getDefault(): UserPreferences {
      return {
         display: {
            IDdisplay: EntityIDdisplay.none            
         } 
      }
   }
   isValid(preferences: UserPreferences): boolean {
      if(!preferences?.display) return false
      return preferences.display.IDdisplay in EntityIDdisplay
   }   
}
